import { Middleware } from '@reduxjs/toolkit'
import { QuickTradeData, setQuickOrderData } from '../reducer/orders.reducer'
import { prepareQuickTradeOpenPayload } from '../util/quickTradePreferences'

export const quickTradePreferencesMiddleware: Middleware = () => (next) => (action) => {
    if (setQuickOrderData.match(action)) {
        const payload = action.payload as Partial<QuickTradeData>
        if (payload.openDialog === true) {
            return next({
                ...action,
                payload: prepareQuickTradeOpenPayload(payload),
            })
        }
    }
    return next(action)
}
